<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 작업환경 개선 계획서 -->
    <div>
      <div class="flex justify-between items-center my-4">
        <h5><i class="dot"></i> 작업환경 개선 계획서</h5>
        <div v-if="!isPrint && !board.readonly">
          <vs-button class="" color="secondary" type="border" @click="handleAddRow">항목추가 </vs-button>
          <vs-button class="ml-4" color="secondary" @click="handleRemoveRow">선택삭제 </vs-button>
        </div>
      </div>
      <table>
        <colgroup>
          <col width="36" style="background: #f9f9f9" />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col width="100" />
          <col width="100" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th v-if="!isPrint && !board.readonly" rowspan="2" class="p-0"><vs-checkbox :value="0 < form.list.length && checkIds.length === form.list.length" @click.native="onClickAllCheck" class="check" /></th>
            <th rowspan="2">공정명</th>
            <th rowspan="2">작업내용</th>
            <th rowspan="2">문제점<br />(유해요인의 원인)</th>
            <th rowspan="2">근로자 의견</th>
            <th rowspan="2">개선방안</th>
            <th rowspan="2">추진일정</th>
            <th colspan="2">개선우선순위</th>
            <th rowspan="2">개선조치 담당자</th>
          </tr>
          <tr>
            <th>종합</th>
            <th>총 점수</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in form.list" :key="item.id">
            <td v-if="!isPrint && !board.readonly" class="p-0"><vs-checkbox :vs-value="item.id" v-model="checkIds" class="check" /></td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input1 }}</p>
              <ml-input v-else :readonly="board.readonly" v-model="item.input1" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input2 }}</p>
              <ml-input v-else :readonly="board.readonly" v-model="item.input2" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea no-block">{{ item.input3 }}</p>
              <ml-textarea v-else :readonly="board.readonly" rows="3" v-model="item.input3" class="w-full mb-0" />
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea no-block">{{ item.input4 }}</p>
              <ml-textarea v-else :readonly="board.readonly" rows="3" v-model="item.input4" class="w-full mb-0" />
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea no-block">{{ item.input5 }}</p>
              <ml-textarea v-else :readonly="board.readonly" rows="3" v-model="item.input5" class="w-full mb-0" />
            </td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input6 }}</p>
              <DateSelector v-else :readonly="board.readonly" v-model="item.input6" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input7 }}</p>
              <comma-input v-else :readonly="board.readonly" v-model="item.input7" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input8 }}</p>
              <comma-input v-else :readonly="board.readonly" v-model="item.input8" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="text-center">{{ item.input9 }}</p>
              <ml-input v-else :readonly="board.readonly" v-model="item.input9" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      checkIds: [],
      form: {
        stdInfo: {},

        list: [],
        numberId: 0,

        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleAddRow() {
      this.form.list.push({ id: ++this.form.numberId });
    },
    handleRemoveRow() {
      this.form.list = this.form.list.filter((item) => !this.checkIds.includes(item.id));
      this.checkIds = [];
    },
    onClickAllCheck() {
      if (this.checkIds.length === this.form.list.length) this.checkIds = [];
      else this.checkIds = this.form.list.map((item) => item.id);
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 16px 0;

    &:first-child {
      padding: 0;
    }
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 7px;
    &:first-child {
      background: #f9f9f9;
      padding: 0;
    }
  }
}

.check::v-deep {
  justify-content: center !important;
  span {
    margin: 0;
  }
}
</style>
